import React from 'react';
import PortfolioGrid from './GraphicDesign';

const Portfolio = () => {
  return (
    <section id="portfolio" className="py-24 max-w-screen-xl mx-auto px-6">
      <div className="text-center mb-12">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">My Work</span>
        <h2 className="text-4xl font-bold text-text">My Portfolio</h2>
      </div>
      <PortfolioGrid />
    </section>
  );
};

export default Portfolio;
